export * from './access-control-events'
export * from './monetary-events'
export * from './support-events'
export * from './organization-events'
export * from './diagnostic-events'
export * from './support-events'
export * from './stakeholder-events'
export * from './ai-events'
import { AccessControl } from './access-control-events'
import { Diagnostic } from './diagnostic-events'
import { Organization } from './organization-events'
import { Support } from './support-events'
import { Monetary } from './monetary-events'
import { Stakeholder } from './stakeholder-events'
import { Ai } from './ai-events'

export const signalREvent = {
  AccessControl,
  Diagnostic,
  Organization,
  Support,
  Monetary,
  Stakeholder,
  Ai
} as const
